import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function MarketplaceProductsPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Marketplace",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/marketplace/products" />
    </Container>
  );
}

export default MarketplaceProductsPage;